import React, { useEffect, useRef, useState } from "react";
import { getDayName, getSecondaryMonthName } from "./placeUtils";
import { getLocalizedCelebration } from "./localizedContent";
import { useLanguage } from "./LanguageContext";

function UpcomingEvent(props){
  const { language } = useLanguage();
  const event = getLocalizedCelebration(props.event, language);

  const [isExpanded, setIsExpanded] = useState(false);
  const [hasMoreContent, setHasMoreContent] = useState(false);
  const contentRef = useRef(null);
  const eventContent = String(event.content || "");

  useEffect(() => {
    setIsExpanded(false);
    setHasMoreContent(false);
  }, [event]);

  useEffect(() => {
    const contentElement = contentRef.current;
    if (!contentElement || isExpanded) return undefined;

    const measureContent = () => {
      const measurementElement = contentElement.cloneNode(true);
      const computedStyle = window.getComputedStyle(contentElement);
      const lineHeight = parseFloat(computedStyle.lineHeight);

      measurementElement.classList.remove("is-expanded");
      measurementElement.style.position = "absolute";
      measurementElement.style.visibility = "hidden";
      measurementElement.style.width = `${contentElement.clientWidth}px`;
      measurementElement.style.height = "auto";
      measurementElement.style.maxHeight = "none";
      measurementElement.style.display = "block";
      measurementElement.style.webkitLineClamp = "unset";
      document.body.appendChild(measurementElement);

      setHasMoreContent(measurementElement.scrollHeight > lineHeight * 5 + 1);
      measurementElement.remove();
    };

    const frame = window.requestAnimationFrame(measureContent);
    const resizeObserver = new ResizeObserver(measureContent);

    resizeObserver.observe(contentElement);
    window.addEventListener("resize", measureContent);

    return () => {
      window.cancelAnimationFrame(frame);
      resizeObserver.disconnect();
      window.removeEventListener("resize", measureContent);
    };
  }, [eventContent, isExpanded]);

    return(
        <div className={`upcoming-event ${isExpanded ? "is-expanded" : ""}`}>
            <div className="jumbotron">
  <h1 className="display-4">{event.title}</h1>
  <p className="lead upcoming-event-date">
    {getDayName(event.day, event.month, new Date().getFullYear())}, {event.day} {getSecondaryMonthName(event.month)}
    </p>
  <hr className="my-4"></hr>
  <p ref={contentRef} className={`event-content ${isExpanded ? "is-expanded" : ""}`}>{eventContent}</p>
  {hasMoreContent && (
    <button className="event-content-toggle" type="button" onClick={() => setIsExpanded((expanded) => !expanded)}>
      {isExpanded ? (language === "en" ? "Show less" : "Zwiń") : (language === "en" ? "Read more" : "Czytaj więcej")}
    </button>
  )}
  <p className="event-author">{language === "en" ? "author" : "autor"}: {event.author}</p>
  {/* <p class="lead">
    <a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a>
  </p> */}
</div>
        </div>
    );
};

export default UpcomingEvent;

